function zika(){
	return {
		"games":[
					
					{
						"informs":[
									{
										"text":"Os sintomas mais comuns associados ao vírus Zika são: vermelhidão em todo o corpo com muita “coceira” depois de alguns dias; febre baixa, que muitas vezes nem se percebe.",
										"title":"Sintomas",
										"image":"images/games/informs/zika/sintomas/1.jpg",
									},
									{
										"text":"Conjuntivite (olho vermelho) sem secreção; dores musculares e dor de cabeça; dor nas juntas. Todos os sintomas são de intensidade de leve a moderada.",
										"title":"Sintomas",
										"image":"images/games/informs/zika/sintomas/2.jpg",
									}
								],
						"pathImageGame":"midias/images/games/puzzles/zika/sintomas/1.jpg"
					},
					{
						"informs":[
									{
										"text":"O tratamento do Zika Vírus é feito de acordo com os sintomas, com o uso de analgésicos, antitérmicos e outros medicamentos disponíveis em qualquer unidade pública de saúde para controlar a febre e a dor.",
										"title":"tratamento",
										"image":"images/games/informs/zika/tratamento/1.jpg",
									},
									{
										"text":"Mulheres grávidas quando infectadas pelo Zika vírus podem ter seus fetos afetados por eles. Este vírus pode provocar lesões em vários locais no feto, particularmente no sistema nervoso. As pacientes necessitam acompanhamento médico para avaliar o melhor tratamento a ser aplicado.",
										"title":"tratamento",
										"image":"images/games/informs/zika/tratamento/2.jpg",
									},
									{
										"text":"Os bebês, de mães que foram infectadas pelo Zika, devem se acompanhados em centros especializados para que as sequelas, se houver, sejam acompanhadas por profissionais especializados.",
										"title":"tratamento",
										"image":"images/games/informs/zika/tratamento/3.jpg",
									}
								],
						"pathImageGame":"midias/images/games/puzzles/zika/tratamento/1.jpg"
					},
					{
						"informs":[
									{
										"text":"O Zika Vìrus(ZIKV) de uma floresta chamada Zika, em Uganda, na África.",
										"title":"Curiosidades",
										"image":"images/games/informs/zika/curiosidades/1.jpg",
									},
									{
										"text":"Esse vírus começou a se hospedar em mamíferos, principalmente em primatas e recebeu o nome de Zika Vírus ou ZIKV.",
										"title":"Curiosidades",
										"image":"images/games/informs/zika/curiosidades/2.jpg",
									}
								],
						"pathImageGame":"midias/images/games/puzzles/zika/curiosidades/2.jpg"
					}
				]
	};
}

export {zika};
